export enum eventType {
	ondemand = 'ONDEMAND',
	normal = 'NORMAL',
	online = 'ONLINE',
}

export const DEFAULT_IMAGE =
	'https://d1gkntzr8mxq7s.cloudfront.net/65df83b3c4d68.svg'
